import React, { useState } from 'react';
import { ChartBarIcon, CalendarIcon } from '@heroicons/react/24/outline';

const MOCK_METRICS = [
  { id: 'revenue', name: 'Revenue Trend' },
  { id: 'utilization', name: 'Resource Utilization' },
  { id: 'profitability', name: 'Project Profitability' },
  { id: 'pipeline', name: 'Sales Pipeline' }
];

export function Reports() {
  const [selectedMetric, setSelectedMetric] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  return (
    <div className="space-y-6">
      <div className="bg-gray-800 rounded-lg p-6">
        <h1 className="text-2xl font-bold text-white mb-2">Reports</h1>
        <p className="text-gray-400">Generate custom reports and analytics</p>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Metric
            </label>
            <select
              value={selectedMetric}
              onChange={(e) => setSelectedMetric(e.target.value)}
              className="w-full rounded-md border-gray-700 bg-gray-900 text-white shadow-sm focus:border-red-500 focus:ring-red-500 px-4 py-3"
            >
              <option value="">Select a metric</option>
              {MOCK_METRICS.map((metric) => (
                <option key={metric.id} value={metric.id}>
                  {metric.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Start Date
            </label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full rounded-md border-gray-700 bg-gray-900 text-white shadow-sm focus:border-red-500 focus:ring-red-500 px-4 py-3"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              End Date
            </label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="w-full rounded-md border-gray-700 bg-gray-900 text-white shadow-sm focus:border-red-500 focus:ring-red-500 px-4 py-3"
            />
          </div>
        </div>

        <button
          className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Generate Report
        </button>
      </div>

      <div className="bg-gray-800 rounded-lg p-6">
        <div className="flex items-center mb-4">
          <ChartBarIcon className="h-6 w-6 text-red-500 mr-2" />
          <h2 className="text-xl font-semibold text-white">Report Preview</h2>
        </div>
        <div className="h-96 flex items-center justify-center border-2 border-dashed border-gray-700 rounded-lg">
          <div className="text-center">
            <ChartBarIcon className="h-12 w-12 text-gray-500 mx-auto mb-4" />
            <p className="text-gray-500">Select metrics and date range to generate a report</p>
          </div>
        </div>
      </div>
    </div>
  );
}